import React, { useEffect, useRef } from 'react';
import { Box, IconButton, InputAdornment, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

import { ButtonUI, InputUI } from '../../Interface';

const IncomingItem = ({
  incomingFilter,
  onIncomingFilterChange,
  onSearchIncomingItem,
  incomingItem,
  onClearIncomingItem,
  isIncomingBatchManaged,
  incomingBatchSn,
  onIncomingBatchSnChange,
  incomingLot,
  onIncomingLotChange,
  incomingQty,
  onIncomingQtyChange,
  incomingQtyUnitCode,
  quantityInputStep,
  onAddIncomingLine,
}) => {
  const batchSnInputRef = useRef(null);
  const lotInputRef = useRef(null);
  const qtyInputRef = useRef(null);

  useEffect(() => {
    if (!incomingItem) return;

    const nextTarget = isIncomingBatchManaged ? batchSnInputRef.current : qtyInputRef.current;
    if (nextTarget && typeof nextTarget.focus === 'function') {
      nextTarget.focus();
    }
  }, [incomingItem, isIncomingBatchManaged]);

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 1.5,
        bgcolor: 'grey.100',
        mt: 1.5,
      }}
    >
      <Box sx={{ bgcolor: 'white' }}>
        <InputUI
          fullWidth
          size="small"
          label="Vonalkód / cikkszám"
          value={incomingFilter}
          onChange={(e) => onIncomingFilterChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onSearchIncomingItem();
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" edge="end" aria-label="Keresés" onClick={onSearchIncomingItem}>
                  <SearchIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {incomingItem ? (
        <Box sx={{ mt: 1, p: 1.25, border: '1px solid', borderColor: 'divider', borderRadius: 1, bgcolor: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
            <Typography variant="subtitle2" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
              <Box component="span" sx={{ fontWeight: 700 }}>
                {incomingItem?.itemCode}
              </Box>
              {' - '}
              {incomingItem?.item?.itemName ?? incomingItem?.itemName ?? ''}
            </Typography>

            {onClearIncomingItem ? (
              <IconButton size="small" aria-label="Törlés" onClick={onClearIncomingItem}>
                <CloseIcon fontSize="small" />
              </IconButton>
            ) : null}
          </Box>

          {isIncomingBatchManaged ? (
            <>
              <InputUI
                fullWidth
                size="small"
                label="Sarzs"
                value={incomingBatchSn}
                onChange={(e) => onIncomingBatchSnChange(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key !== 'Enter') return;
                  e.preventDefault();
                  lotInputRef.current?.focus?.();
                }}
                inputRef={batchSnInputRef}
                sx={{ mt: 1 }}
              />
              <InputUI
                fullWidth
                size="small"
                label="LOT szám"
                value={incomingLot}
                onChange={(e) => onIncomingLotChange(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key !== 'Enter') return;
                  e.preventDefault();
                  qtyInputRef.current?.focus?.();
                }}
                inputRef={lotInputRef}
                sx={{ mt: 1 }}
              />
            </>
          ) : null}

          <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
            <InputUI
              name="incomingQty"
              type="number"
              size="small"
              label="Mennyiség"
              sx={{ width: 120 }}
              inputProps={{ min: 0, step: quantityInputStep ?? '1' }}
              value={incomingQty}
              onChange={(e) => onIncomingQtyChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== 'Enter') return;
                e.preventDefault();
                onAddIncomingLine();
              }}
              inputRef={qtyInputRef}
            />
            <Typography variant="body2" color="text.secondary">
              {incomingQtyUnitCode}
            </Typography>
            <ButtonUI text="Bejövő tétel rögzítése" className="bg-success" onClick={onAddIncomingLine} />
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};

export default IncomingItem;
